module.exports = __webpack_public_path__ + "templates.store_pick_up_options-01dd6251.html";